// eslint-disable-next-line import/prefer-default-export
export const GROUP_PICKER_ACTIONS = {
  REHYDRATE: "REHYDRATE",
  RESIZE: "RESIZE",
  SET_GROUP: "SET_GROUP",
  RESET_GROUP: "RESET_GROUP",
};
